import React, { useContext, useState } from "react";
import { FaUser, FaBars, FaTimes, FaPhone, FaSignOutAlt, FaUserCircle, FaTachometerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";  // Import AuthContext

const Navbar = () => {
    const { isAuthenticated, userData, logout } = useContext(AuthContext);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };


    return (
        <nav className="bg-white shadow-md py-5 flex justify-center sticky top-0 z-[10] transition">
            <div className="container mx-auto flex justify-between items-center px-0 xl:w-[1440px]">
                {/* Logo */}
                <Link to="/" className="flex items-center">
                    <img src="/images/riskdiscover-logo-clean.png" alt="RiskDiscover" className="h-10 w-auto object-contain" />
                </Link>

                {/* Navigation Links */}
                <ul className="hidden md:flex space-x-6 font-['ArchivoExpandMid'] transition">
                    <li><Link to="/" className="text-[rgba(10,0,82)] text-[14px] border border-white hover:border-b-[rgba(10,0,82)]">Home</Link></li>
                    {isAuthenticated && (
                        <li><Link to="/dashboard" className="text-[rgba(10,0,82)] text-[14px] border border-white hover:border-b-[rgba(10,0,82)] font-semibold">My Dashboard</Link></li>
                    )}
                    <li><Link to="/products" className="text-[rgba(10,0,82)] text-[14px] border border-white hover:border-b-[rgba(10,0,82)]">Products</Link></li>
                    <li><Link to="/features" className="text-[rgba(10,0,82)] text-[14px] border border-white hover:border-b-[rgba(10,0,82)]">Features</Link></li>
                    <li><Link to="/about" className="text-[rgba(10,0,82)] text-[14px] border border-white hover:border-b-[rgba(10,0,82)]">About Us</Link></li>
                </ul>

                {/* Authentication Buttons */}
                <div className="hidden md:flex space-x-6 font-['ArchivoExpandMid']">
                    {isAuthenticated ? (
                        <div className="relative group flex items-center">
                            <span className="text-white font-medium cursor-pointer px-4 py-2 text-center border-none rounded-[4px] bg-red-600 text-sm">
                                {userData?.firstName || "User"}
                            </span>
                            <div className="absolute right-0 top-12 mt-2 w-52 bg-white border rounded-lg shadow-xl opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all duration-200 z-20">
                                <Link
                                    to="/dashboard"
                                    className="flex items-center gap-3 px-5 py-3 text-sm text-gray-700 hover:bg-gray-100 rounded-t-lg"
                                >
                                    <FaTachometerAlt className="text-lg text-blue-500" /> My Dashboard
                                </Link>
                                <Link
                                    to="/profile"
                                    className="flex items-center gap-3 px-5 py-3 text-sm text-gray-700 hover:bg-gray-100"
                                >
                                    <FaUserCircle className="text-lg text-gray-500" /> Profile
                                </Link>
                                <button
                                    onClick={logout}
                                    className="flex items-center gap-3 w-full text-left px-5 py-3 text-sm text-red-600 hover:bg-gray-100 rounded-b-lg"
                                >
                                    <FaSignOutAlt className="text-lg" /> Logout
                                </button>
                            </div>
                        </div>
                    ) : (
                        <Link to="/auth/signin">
                            <button className="flex items-center px-4 py-2 bg-[rgb(71,63,125)] text-white rounded-[4px] text-sm">
                                <FaUser className="mr-2" /> Login
                            </button>
                        </Link>
                    )}
                    <Link to="/contact">
                        <button className="flex items-center border border-[rgb(71,63,125,0.4)] px-4 py-2 rounded-[4px] text-[rgb(10,0,82)] text-sm">
                            <FaPhone className="mr-2" /> Contact
                        </button>
                    </Link>
                </div>

                {/* Mobile Menu Toggle */}
                <button
                    className="md:hidden text-xl text-[rgba(10,0,82)] hover:text-[rgb(71,63,125)] transition-colors"
                    onClick={toggleMobileMenu}
                    aria-label="Toggle mobile menu"
                >
                    {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t z-50">
                    {/* Mobile Navigation Links */}
                    <div className="py-4">
                        <Link
                            to="/"
                            className="block px-6 py-3 text-[rgba(10,0,82)] hover:bg-gray-50 border-b border-gray-100"
                            onClick={closeMobileMenu}
                        >
                            Home
                        </Link>
                        {isAuthenticated && (
                            <Link
                                to="/dashboard"
                                className="block px-6 py-3 text-[rgba(10,0,82)] hover:bg-gray-50 border-b border-gray-100 font-semibold"
                                onClick={closeMobileMenu}
                            >
                                My Dashboard
                            </Link>
                        )}
                        <Link
                            to="/products"
                            className="block px-6 py-3 text-[rgba(10,0,82)] hover:bg-gray-50 border-b border-gray-100"
                            onClick={closeMobileMenu}
                        >
                            Products
                        </Link>
                        <Link
                            to="/features"
                            className="block px-6 py-3 text-[rgba(10,0,82)] hover:bg-gray-50 border-b border-gray-100"
                            onClick={closeMobileMenu}
                        >
                            Features
                        </Link>
                        <Link
                            to="/about"
                            className="block px-6 py-3 text-[rgba(10,0,82)] hover:bg-gray-50 border-b border-gray-100"
                            onClick={closeMobileMenu}
                        >
                            About Us
                        </Link>
                        <Link
                            to="/contact"
                            className="block px-6 py-3 text-[rgba(10,0,82)] hover:bg-gray-50 border-b border-gray-100"
                            onClick={closeMobileMenu}
                        >
                            Contact
                        </Link>
                    </div>

                    {/* Mobile Authentication Section */}
                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                        {isAuthenticated ? (
                            <div className="space-y-3">
                                <div className="flex items-center gap-3 text-sm text-gray-700">
                                    <FaUserCircle className="text-lg text-gray-500" />
                                    <span className="font-medium">{userData?.firstName || "User"}</span>
                                </div>
                                <Link
                                    to="/profile"
                                    className="flex items-center gap-3 py-2 text-sm text-gray-700"
                                    onClick={closeMobileMenu}
                                >
                                    <FaUserCircle className="text-lg text-gray-500" /> Profile
                                </Link>
                                <button
                                    onClick={() => { logout(); closeMobileMenu(); }}
                                    className="flex items-center gap-3 w-full text-left py-2 text-sm text-red-600"
                                >
                                    <FaSignOutAlt className="text-lg" /> Logout
                                </button>
                            </div>
                        ) : (
                            <Link
                                to="/auth/signin"
                                onClick={closeMobileMenu}
                            >
                                <button className="flex items-center justify-center w-full px-4 py-3 bg-[rgb(71,63,125)] text-white rounded-[4px] text-sm">
                                    <FaUser className="mr-2" /> Login
                                </button>
                            </Link>
                        )}
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
